export const ORDER_FROM_ROBO_V2 = 'Order from RoBo V2';